module.exports = __webpack_public_path__ + "static/media/ssl.2c03acb0.svg";